<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canViewVerticalNavMenuGroup(_vm.item)
    ? _c(
        "li",
        {
          staticClass: "nav-item has-sub menu-item-coin",
          class: {
            open: _vm.isOpen,
            disabled: _vm.item.disabled,
            "sidebar-group-active": _vm.isActive,
          },
        },
        [
          _c(
            "b-link",
            {
              staticClass: "d-flex align-items-center menu-txt-outer",
              on: {
                click: function () {
                  return _vm.updateGroupOpen(!_vm.isOpen)
                },
              },
            },
            [
              _c(
                "span",
                { staticClass: "icon-span" },
                [
                  _c("feather-icon", {
                    attrs: { icon: _vm.item.icon || "CircleIcon" },
                  }),
                  _vm.item.icon == "P2p"
                    ? _c("P2p", { staticClass: "custom-icon" })
                    : _vm._e(),
                  _vm.item.icon == "Account"
                    ? _c("Account", { staticClass: "custom-icon" })
                    : _vm._e(),
                ],
                1
              ),
              _c("span", { staticClass: "menu-title text-truncate menu-txt" }, [
                _vm._v(_vm._s(_vm.t(_vm.item.title))),
              ]),
              _vm.item.tag
                ? _c(
                    "b-badge",
                    {
                      staticClass: "mr-1 ml-auto",
                      attrs: {
                        pill: "",
                        variant: _vm.item.tagVariant || "primary",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.item.tag) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "b-collapse",
            {
              staticClass: "menu-content",
              attrs: { tag: "ul" },
              model: {
                value: _vm.isOpen,
                callback: function ($$v) {
                  _vm.isOpen = $$v
                },
                expression: "isOpen",
              },
            },
            _vm._l(_vm.item.children, function (child) {
              return _c(_vm.resolveNavItemComponent(child), {
                key: child.header || child.title,
                ref: "groupChild",
                refInFor: true,
                tag: "component",
                attrs: { item: child },
              })
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-group/VerticalNavMenuGroup.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import core_layouts_utils from '@core/layouts/utils';
import core_libs_i18n from '@core/libs/i18n';
import core_libs_acl from '@core/libs/acl';
import vertical_nav_menu_header from '../vertical-nav-menu-header';
import vertical_nav_menu_link_VerticalNavMenuLink_vue from '../vertical-nav-menu-link/VerticalNavMenuLink.vue';
import useVerticalNavMenuGroup from './useVerticalNavMenuGroup';
import mixinVerticalNavMenuGroup from './mixinVerticalNavMenuGroup';
import assets_rashi_coin_p2p_svg from '@/assets/rashi-coin/p2p.svg';
import assets_rashi_coin_account_svg from '@/assets/rashi-coin/account.svg';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Composition Function




export default ({
  render,
  staticRenderFns,
  name: "VerticalNavMenuGroup",
  components: {
    VerticalNavMenuHeader: vertical_nav_menu_header,
    VerticalNavMenuLink: vertical_nav_menu_link_VerticalNavMenuLink_vue,
    BLink: bootstrapvue["BLink"],
    BBadge: bootstrapvue["BBadge"],
    BCollapse: bootstrapvue["BCollapse"],
    Account: assets_rashi_coin_account_svg,
    P2p: assets_rashi_coin_p2p_svg
  },
  mixins: [mixinVerticalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const {
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive
    } = useVerticalNavMenuGroup(props.item);
    const {
      t
    } = core_libs_i18n.useUtils();
    const {
      canViewVerticalNavMenuGroup
    } = core_libs_acl.useUtils();
    return {
      resolveNavItemComponent: core_layouts_utils["resolveVerticalNavMenuItemComponent"],
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
      // ACL
      canViewVerticalNavMenuGroup,
      // i18n
      t
    };
  }
});

//# sourceURL=webpack:///./src/@core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-group/VerticalNavMenuGroup.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

